// ** Initial State
const initialState = {
  clickAllList: null,
};

const clickEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_CLICK_EVENTS":
      return {
        ...state,
        clickAllList: action.data,
      };

    default:
      return state;
  }
};

export default clickEventReducer;